import React from 'react'
import { Link } from 'react-router-dom'
import {
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded'

const session = require('../../config/session')

function resolverIncidencias(cajero, categoriasEstados) {
  const items = []
  categoriasEstados.forEach((categoria) => {
    categoria.tipos.forEach((tipo) => {
      let estadoEncontrado = null
      tipo.estados.forEach((estado) => {
        cajero.estados.forEach((estadoCajero) => {
          if (estado.id === estadoCajero.estado && estado.codigo_estado === 1) {
            estadoEncontrado = estado
          }
        })
      })
      if (estadoEncontrado) {
        items.push({
          tipoId: tipo.id,
          categoria: categoria.nombre,
          descripcion: estadoEncontrado.descripcion,
          archivo: estadoEncontrado.archivo,
        })
      }
    })
  })
  return items
}

function ItemCajeroIncidencia(props) {
  const cajero = props.cajero
  const incidencias = resolverIncidencias(cajero, props.categoriasEstados)

  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Card
        elevation={0}
        sx={{
          position: 'relative',
          borderRadius: '14px',
          border: '1px solid rgba(211, 47, 47, 0.25)',
          overflow: 'hidden',
          backgroundColor: '#fff',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          transition: 'transform 200ms ease, box-shadow 200ms ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 10px 24px rgba(211,47,47,0.18)',
          },
        }}
      >
        <Box sx={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: 4, backgroundColor: '#D32F2F' }} />

        <Box sx={{ p: 2, pl: 2.5 }}>
          <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={1}>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#222', lineHeight: 1.2 }} noWrap>
                {cajero.alias}
              </Typography>
              <Typography variant="caption" sx={{ color: '#666' }}>
                <strong style={{ color: '#999' }}>Código</strong> {cajero.codigo}
              </Typography>
              <Tooltip title={cajero.serial || ''}>
                <Typography
                  variant="caption"
                  sx={{ color: '#999', display: 'block', fontFamily: 'monospace', mt: 0.25 }}
                  noWrap
                >
                  {cajero.serial}
                </Typography>
              </Tooltip>
            </Box>

            <Chip
              icon={<WarningAmberRoundedIcon sx={{ fontSize: 16, color: '#D32F2F !important' }} />}
              label={`${incidencias.length} ${incidencias.length === 1 ? 'incidencia' : 'incidencias'}`}
              size="small"
              sx={{
                backgroundColor: '#FDECEA',
                color: '#D32F2F',
                fontWeight: 700,
                border: '1px solid rgba(211,47,47,0.3)',
              }}
            />
          </Stack>
        </Box>

        <Divider />

        <Box sx={{ px: 2, py: 1.5, flexGrow: 1 }}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              color: '#D32F2F',
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
              display: 'block',
              mb: 1,
            }}
          >
            Incidencias detectadas
          </Typography>

          {incidencias.length === 0 ? (
            <Typography variant="body2" sx={{ color: '#888' }}>
              Sin detalle disponible.
            </Typography>
          ) : (
            <Stack gap={0.6}>
              {incidencias.map((i) => (
                <Stack
                  key={i.tipoId}
                  direction="row"
                  alignItems="center"
                  gap={1}
                  sx={{
                    py: 0.6,
                    px: 1,
                    borderRadius: '8px',
                    backgroundColor: 'rgba(211,47,47,0.06)',
                  }}
                >
                  <img
                    alt="estado"
                    src={'/estado_cajero/' + i.archivo}
                    width={16}
                    height={16}
                    style={{ flexShrink: 0 }}
                  />
                  <Box sx={{ minWidth: 0 }}>
                    <Typography variant="body2" sx={{ color: '#222', fontWeight: 600, fontSize: '0.85rem', lineHeight: 1.2 }}>
                      {i.descripcion}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#888' }}>
                      {i.categoria}
                    </Typography>
                  </Box>
                </Stack>
              ))}
            </Stack>
          )}
        </Box>

        <Box sx={{ p: 2, pt: 1 }}>
          {session.checkPermiso('acceder_cajeros_resumen') && (
            <Link
              to={{ pathname: '/dashboard/cajeros/resumen', state: { id_cajero: cajero.id } }}
              style={{ textDecoration: 'none' }}
            >
              <Button
                fullWidth
                variant="contained"
                disableElevation
                endIcon={<OpenInNewRoundedIcon />}
                sx={{
                  borderRadius: '10px',
                  backgroundColor: '#D32F2F',
                  fontWeight: 700,
                  textTransform: 'none',
                  '&:hover': { backgroundColor: '#B71C1C' },
                }}
              >
                Atender cajero
              </Button>
            </Link>
          )}
        </Box>
      </Card>
    </Grid>
  )
}

export default ItemCajeroIncidencia
